import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';

export const StyledMenu = styled(Menu)`
  .MuiMenu-paper {
    box-shadow: none;
  }
`;
